module.exports = __webpack_public_path__ + "img/logo-image-3.43e113be.png";